import styled from 'styled-components';
import { Vehicle } from '../../../../types/vehicle';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { openCarInfoDialog } from '../../../../services/listerUploadVehicle/v2';
import { useDeviceInfo } from 'hooks/useDeviceInfo';

type Props = { vehicle: Vehicle };

const Wrapper = styled.div`
  display: flex;
  gap: 8px;
  height: 36px;

  @media (min-width: 1200px) {
    flex-direction: column;
    height: unset;
  }
`;

const Action = styled.div`
  border-radius: 8px;
  display: flex;
  align-items: center;
  cursor: pointer;
  justify-content: center;
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  line-height: 14.06px;
  flex: 1 1 100%;

  @media (orientation: landscape) {
    min-width: 140px;
  }

  @media (min-width: 1200px) {
    min-height: 36px;
    min-width: 140px;
  }
`;

const ViewAction = styled(Action)`
  background: rgba(57, 148, 222, 1);
`;

const EditAction = styled(Action)`
  background: rgba(66, 66, 66, 1);
`;

export const Actions = ({ vehicle }: Props) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const { isMobile } = useDeviceInfo();

  const handleView = () => history.push(`/vehicles/${vehicle.id}/view`);
  const handleEdit = () => {
    if (!isMobile) {
      return history.push(`/vehicles/${vehicle.id}/review`);
    }

    const shouldOpenEditModal = !vehicle.mileage;
    if (shouldOpenEditModal) {
      return dispatch(openCarInfoDialog({ vehicleId: vehicle.id, type: 'edit' }));
    }
    return history.push(`/lister/upload-vehicle/v2/${vehicle.id}`);
  };

  return (
    <Wrapper>
      <ViewAction onClick={handleView}>View</ViewAction>
      <EditAction onClick={handleEdit}>Edit</EditAction>
    </Wrapper>
  );
};
